module.exports = __webpack_public_path__ + "media/landing/hl-logo-18dad2a1.png";